import React from 'react'
import { LogoutIcon } from '../../../components/icons/onboarding'
import Logo from '../../../components/Logo'

const Header = ({ history, logOut }) => {
  return (
    <div className="header">
      <Logo className="setup-logo" />
      <div className="log-out" onClick={() => logOut(history)}>
        <LogoutIcon />
        LOG OUT
      </div>
    </div>
  )
}

export default Header
